export const MODAL_OVERLAY_ID = 'cs-modal';
